import React from 'react';
import { MoreHorizontal } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../../ui/dropdown-menu';
import { getStatusTone, isDestructiveStatus, TONE_MARK } from '../shared/orderStatus';

/*
 * Every status the API offers, including the ones outside the lifecycle the
 * stepper draws.
 *
 * The stepper covers the happy path Nysmah drives — Placed, Confirmed, Ready —
 * so without this menu a status like Cancelled would be unreachable once the
 * old catch-all dropdown was removed. Destructive choices still route through
 * the same confirmation as everywhere else; this only exposes them.
 */
const OrderActionsMenu = ({ statusOptions, currentStatusId, onSelectStatus }) => {
  const destructive = statusOptions.filter((option) =>
    isDestructiveStatus(option.value),
  );
  const regular = statusOptions.filter(
    (option) => !isDestructiveStatus(option.value),
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="More order actions"
          className="inline-flex items-center justify-center rounded-lg border border-transparent bg-transparent p-1.5 text-nysmah-muted hover:text-nysmah-dark hover:bg-[#F0F4F5] cursor-pointer transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-nysmah-accent"
        >
          <MoreHorizontal className="w-4 h-4" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-[0.07em] text-nysmah-muted">
          Set status
        </DropdownMenuLabel>
        {regular.map((option) => (
          <DropdownMenuItem
            key={option.value}
            disabled={option.value === currentStatusId}
            onSelect={() => onSelectStatus(option.value)}
            className="text-[12.5px] gap-2"
          >
            <span
              className="w-1.5 h-1.5 rounded-full shrink-0"
              style={{ backgroundColor: TONE_MARK[getStatusTone(option.value)] }}
              aria-hidden="true"
            />
            {option.label}
          </DropdownMenuItem>
        ))}
        {destructive.length > 0 && (
          <>
            <DropdownMenuSeparator />
            {destructive.map((option) => (
              <DropdownMenuItem
                key={option.value}
                disabled={option.value === currentStatusId}
                onSelect={() => onSelectStatus(option.value)}
                className="text-[12.5px] gap-2 text-[#C2453D] focus:text-[#C2453D] focus:bg-[#FCF2F2]"
              >
                <span
                  className="w-1.5 h-1.5 rounded-full shrink-0"
                  style={{ backgroundColor: TONE_MARK.danger }}
                  aria-hidden="true"
                />
                {option.label}
              </DropdownMenuItem>
            ))}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default OrderActionsMenu;
